import React from 'react'

const NextPreviousMonth = (props: any) => {
  const { setCurrentMonth, currentMonth, setRefetch } = props
  const handleNextMonth = () => {
    let nextMonth = currentMonth.add(1, 'months')
    setCurrentMonth(nextMonth)
    setRefetch(nextMonth.format('YYYY-MM-DD'))
  }
  const handlePreviousMonth = () => {
    let previousMonth = currentMonth.subtract(1, 'months')
    setCurrentMonth(previousMonth)
    setRefetch(previousMonth.format('YYYY-MM-DD'))

  }
  return (
    <div className='flex gap-x-4 text-2xl'>
      <div className='border-2 border-primary px-4 pt-1 flex justify-center items-center' title='Previous Month Record' onClick={handlePreviousMonth}>
        &#706;&#706;
      </div>
      <button className='border-2 border-primary px-4 pt-1 flex justify-center items-center' title='Next Month Record' onClick={handleNextMonth}>
        &#707;&#707;
      </button>
    </div>
  )
}

export default NextPreviousMonth
